// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type {
  TagSourceType,
  TagKindDynamicString,
  TagKindDynamicBoolean,
  TagKindDynamicNumber,
  TagKindDynamicVoid,
  TagKindChannel,
  TagKindPrimarySkill,
  TagKindSkill,
  TagKindKeyQuality,
  TagKindClassification,
  TagKindParentalSetting,
  ParentalSettingType,
  Tag,
} from "../schema";
import { serialize_TagSourceType_internal, deserialize_TagSourceType_internal } from "./TagSourceType";
import { serialize_TagKindDynamicString_internal, deserialize_TagKindDynamicString_internal } from "./TagKindDynamicString";
import { serialize_TagKindDynamicBoolean_internal, deserialize_TagKindDynamicBoolean_internal } from "./TagKindDynamicBoolean";
import { serialize_TagKindDynamicNumber_internal, deserialize_TagKindDynamicNumber_internal } from "./TagKindDynamicNumber";
import { serialize_TagKindDynamicVoid_internal, deserialize_TagKindDynamicVoid_internal } from "./TagKindDynamicVoid";
import { serialize_TagKindChannel_internal, deserialize_TagKindChannel_internal } from "./TagKindChannel";
import { serialize_TagKindPrimarySkill_internal, deserialize_TagKindPrimarySkill_internal } from "./TagKindPrimarySkill";
import { serialize_TagKindSkill_internal, deserialize_TagKindSkill_internal } from "./TagKindSkill";
import { serialize_TagKindKeyQuality_internal, deserialize_TagKindKeyQuality_internal } from "./TagKindKeyQuality";
import { serialize_TagKindClassification_internal, deserialize_TagKindClassification_internal } from "./TagKindClassification";
import { serialize_TagKindParentalSetting_internal, deserialize_TagKindParentalSetting_internal } from "./TagKindParentalSetting";
import { serialize_ParentalSettingType_internal, deserialize_ParentalSettingType_internal } from "./ParentalSettingType";

export function serialize_Tag_internal(value: Tag): unknown {
  return ((
    value:
      | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
      | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
      | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
      | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
      | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
      | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
      | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
      | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
      | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
      | { discriminator: "parental-setting"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindParentalSetting; value: ParentalSettingType },
  ): unknown => {
    switch (value.discriminator) {
      case "dynamicString": {
        return {
          discriminator: "dynamicString",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindDynamicString): unknown => {
            return serialize_TagKindDynamicString_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "dynamicBoolean": {
        return {
          discriminator: "dynamicBoolean",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindDynamicBoolean): unknown => {
            return serialize_TagKindDynamicBoolean_internal(value);
          })(value["tagKind"]),
          value: ((value: boolean): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "dynamicNumber": {
        return {
          discriminator: "dynamicNumber",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindDynamicNumber): unknown => {
            return serialize_TagKindDynamicNumber_internal(value);
          })(value["tagKind"]),
          value: ((value: number): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "dynamicVoid": {
        return {
          discriminator: "dynamicVoid",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindDynamicVoid): unknown => {
            return serialize_TagKindDynamicVoid_internal(value);
          })(value["tagKind"]),
        };
      }
      case "channel": {
        return {
          discriminator: "channel",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindChannel): unknown => {
            return serialize_TagKindChannel_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "primary-skill": {
        return {
          discriminator: "primary-skill",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindPrimarySkill): unknown => {
            return serialize_TagKindPrimarySkill_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "skill": {
        return {
          discriminator: "skill",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindSkill): unknown => {
            return serialize_TagKindSkill_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "key-quality": {
        return {
          discriminator: "key-quality",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindKeyQuality): unknown => {
            return serialize_TagKindKeyQuality_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "classification": {
        return {
          discriminator: "classification",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindClassification): unknown => {
            return serialize_TagKindClassification_internal(value);
          })(value["tagKind"]),
          value: ((value: string): unknown => {
            return value;
          })(value["value"]),
        };
      }
      case "parental-setting": {
        return {
          discriminator: "parental-setting",
          exclude: ((value: boolean): unknown => {
            return value;
          })(value["exclude"]),
          score: ((value: number): unknown => {
            return value;
          })(value["score"]),
          source: ((value: TagSourceType): unknown => {
            return serialize_TagSourceType_internal(value);
          })(value["source"]),
          tagKind: ((value: TagKindParentalSetting): unknown => {
            return serialize_TagKindParentalSetting_internal(value);
          })(value["tagKind"]),
          value: ((value: ParentalSettingType): unknown => {
            return serialize_ParentalSettingType_internal(value);
          })(value["value"]),
        };
      }
    }
  })(value);
}
export function serialize_Tag(obj: Tag): string {
  return renderJsonWithNumbersAsBigint(serialize_Tag_internal(obj));
}
export function deserialize_Tag_internal(value: unknown): ParserResult<Tag> {
  return ((
    value: unknown,
  ): ParserResult<
    | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
    | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
    | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
    | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
    | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
    | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
    | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
    | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
    | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
    | { discriminator: "parental-setting"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindParentalSetting; value: ParentalSettingType }
  > => {
    return ((
      value: unknown,
    ): ParserResult<
      | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
      | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
      | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
      | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
      | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
      | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
      | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
      | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
      | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
      | { discriminator: "parental-setting"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindParentalSetting; value: ParentalSettingType }
    > => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/Tag]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/Tag]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "discriminator")) {
        return { success: false, reason: `[#/components/schemas/Tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
      }
      if (typeof value["discriminator"] != "string") {
        return { success: false, reason: `[#/components/schemas/Tag]: '${value["discriminator"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["discriminator"];
      switch (discriminator) {
        case "dynamicString": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindDynamicString;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindDynamicString> => {
              return ((value: unknown): ParserResult<TagKindDynamicString> => {
                return deserialize_TagKindDynamicString_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "dynamicString" as const, ...parsedVariant.value } };
        }
        case "dynamicBoolean": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindDynamicBoolean;
            value: boolean;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindDynamicBoolean> => {
              return ((value: unknown): ParserResult<TagKindDynamicBoolean> => {
                return deserialize_TagKindDynamicBoolean_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "dynamicBoolean" as const, ...parsedVariant.value } };
        }
        case "dynamicNumber": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindDynamicNumber;
            value: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindDynamicNumber> => {
              return ((value: unknown): ParserResult<TagKindDynamicNumber> => {
                return deserialize_TagKindDynamicNumber_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${value}' expected to be of type number.` };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "dynamicNumber" as const, ...parsedVariant.value } };
        }
        case "dynamicVoid": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindDynamicVoid;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindDynamicVoid> => {
              return ((value: unknown): ParserResult<TagKindDynamicVoid> => {
                return deserialize_TagKindDynamicVoid_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "dynamicVoid" as const, ...parsedVariant.value } };
        }
        case "channel": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindChannel;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/channel/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/channel/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindChannel> => {
              return ((value: unknown): ParserResult<TagKindChannel> => {
                return deserialize_TagKindChannel_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "channel" as const, ...parsedVariant.value } };
        }
        case "primary-skill": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindPrimarySkill;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindPrimarySkill> => {
              return ((value: unknown): ParserResult<TagKindPrimarySkill> => {
                return deserialize_TagKindPrimarySkill_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "primary-skill" as const, ...parsedVariant.value } };
        }
        case "skill": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindSkill;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindSkill> => {
              return ((value: unknown): ParserResult<TagKindSkill> => {
                return deserialize_TagKindSkill_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "skill" as const, ...parsedVariant.value } };
        }
        case "key-quality": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindKeyQuality;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindKeyQuality> => {
              return ((value: unknown): ParserResult<TagKindKeyQuality> => {
                return deserialize_TagKindKeyQuality_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "key-quality" as const, ...parsedVariant.value } };
        }
        case "classification": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindClassification;
            value: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/classification/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/classification/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindClassification> => {
              return ((value: unknown): ParserResult<TagKindClassification> => {
                return deserialize_TagKindClassification_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "classification" as const, ...parsedVariant.value } };
        }
        case "parental-setting": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            exclude: boolean;
            score: number;
            source: TagSourceType;
            tagKind: TagKindParentalSetting;
            value: ParentalSettingType;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "exclude")) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
            }
            const parsed_exclude = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/Tag/parental-setting/exclude]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["exclude"]);
            })();
            if (!parsed_exclude.success) {
              return { success: false, reason: parsed_exclude.reason };
            }
            if (!hasProp(value, "score")) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
            }
            const parsed_score = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: Number(value) };
                }
                return { success: false, reason: `[#/components/schemas/Tag/parental-setting/score]: '${value}' expected to be of type number or bigint.` };
              })(value["score"]);
            })();
            if (!parsed_score.success) {
              return { success: false, reason: parsed_score.reason };
            }
            if (!hasProp(value, "source")) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
            }
            const parsed_source = ((): ParserResult<TagSourceType> => {
              return ((value: unknown): ParserResult<TagSourceType> => {
                return deserialize_TagSourceType_internal(value);
              })(value["source"]);
            })();
            if (!parsed_source.success) {
              return { success: false, reason: parsed_source.reason };
            }
            if (!hasProp(value, "tagKind")) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
            }
            const parsed_tagKind = ((): ParserResult<TagKindParentalSetting> => {
              return ((value: unknown): ParserResult<TagKindParentalSetting> => {
                return deserialize_TagKindParentalSetting_internal(value);
              })(value["tagKind"]);
            })();
            if (!parsed_tagKind.success) {
              return { success: false, reason: parsed_tagKind.reason };
            }
            if (!hasProp(value, "value")) {
              return { success: false, reason: `[#/components/schemas/Tag/parental-setting/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
            }
            const parsed_value = ((): ParserResult<ParentalSettingType> => {
              return ((value: unknown): ParserResult<ParentalSettingType> => {
                return deserialize_ParentalSettingType_internal(value);
              })(value["value"]);
            })();
            if (!parsed_value.success) {
              return { success: false, reason: parsed_value.reason };
            }
            return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { discriminator: "parental-setting" as const, ...parsedVariant.value } };
        }
        default:
          return {
            success: false,
            reason: `[#/components/schemas/Tag]: '${discriminator}' expected to be one of 'dynamicString, dynamicBoolean, dynamicNumber, dynamicVoid, channel, primary-skill, skill, key-quality, classification, parental-setting'.`,
          };
      }
    })(value);
  })(value);
}
export function deserialize_Tag(str: string): ParserResult<Tag> {
  return deserialize_Tag_internal(parseJsonWithNumbersAsBigint(str));
}
